import { faCancel, faCube, faFile, faFileImage, faFilePdf, faTable } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FileNameContainer, Label, RemoveFileIcon } from '../styles';

type FileNameProps = Readonly<{
  fileName?: string;
  removeFile?: () => void;
}>;

export function FileName({ fileName, removeFile }: FileNameProps) {
  const handleRemoveFile = () => {
    /* istanbul ignore next */
    if (!fileName || !removeFile) return;
    removeFile();
  };
  return (
    <FileNameContainer>
      {removeFile ? (
        <RemoveFileIcon onClick={handleRemoveFile} data-testid="remove-file-button">
          <FontAwesomeIcon icon={faCancel} />
        </RemoveFileIcon>
      ) : null}
      <Label>
        <FileIcon fileName={fileName} /> {fileName}
      </Label>
    </FileNameContainer>
  );
}

const cadFileExtensions = [
  'step',
  'stp',
  'jt',
  'x_t',
  'x_b',
  'sldprt',
  'sldasm',
  'prt',
  'asm',
  'f3d',
  'ipt',
  'iam',
  'ipn',
  'idw',
  '3dxml',
  'solidworks',
  'glb',
  'gltf',
  'blend',
];

export function FileIcon({ fileName }: { fileName: string | undefined }) {
  /* istanbul ignore next */
  if (!fileName) return null;

  /* istanbul ignore next */
  if (fileName.endsWith('.pdf')) {
    return <FontAwesomeIcon icon={faFilePdf} size="lg" />;
  }
  /* istanbul ignore next */
  if (fileName.match(/.(jpeg|jpg|png)$/)) {
    return <FontAwesomeIcon icon={faFileImage} size="lg" />;
  }
  if (cadFileExtensions.some((ext) => fileName.endsWith(`.${ext}`))) {
    return <FontAwesomeIcon icon={faCube} size="lg" />;
  }
  if (fileName.match(/.(xls|xlsx)$/)) {
    return <FontAwesomeIcon icon={faTable} size="lg" />;
  }

  /* istanbul ignore next */
  return <FontAwesomeIcon icon={faFile} size="lg" />;
}
